import React from "react";
import { Container } from "react-bootstrap";
import WorkGallery from "../components/Work/WorkGallery";

const Work = () => {
  return (
    <Container fluid>
      <WorkGallery />
    </Container>
  );
};

export default Work;
